import CCColors, {updateColorWithOpacity} from '@/Utils/CCColors';
import {FontSizes, WINDOW_HEIGHT, vs} from '@/Utils/Dimensions';
import {StyleSheet} from 'react-native';

const customStyles = StyleSheet.create({
  childSeq: {
    borderLeftWidth: 1,
    borderLeftColor: CCColors.Black,
    paddingTop: 10,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  annotationIconsWrapper: {
    padding: 5,
    backgroundColor: CCColors?.Primary?.Action,
    borderRadius: 4,
    marginLeft: 5,
  },
  annotationIcons: {
    width: 14,
    height: 14,
    // opacity: 0.6,
    // backgroundColor: CCColors.Primary.Default,
    // borderRadius: 35,
  },
  eachMoveWrapper: {
    borderColor: CCColors.Grey.Border,
    borderWidth: StyleSheet.hairlineWidth,
    backgroundColor: CCColors.White,
    padding: 15,
    paddingBottom: 0,
    paddingTop: 0,
    justifyContent: 'center',
  },
  eachMoveWrapperSolve: {
    borderColor: CCColors.Grey.Border,
    borderWidth: StyleSheet.hairlineWidth,
    backgroundColor: CCColors.White,
    paddingHorizontal: 5,
    paddingVertical: 15,
    paddingBottom: 0,
    paddingTop: 0,
    justifyContent: 'center',
  },
  eachMoveWrapper1: {
    borderColor: CCColors.Grey.Border,
    borderWidth: StyleSheet.hairlineWidth,
    borderTopLeftRadius: 12,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    backgroundColor: CCColors.White,
    padding: 15,
    paddingBottom: 0,
    paddingTop: 0,
    justifyContent: 'center',
  },
  eachMoveWrapper2: {
    borderColor: CCColors.Grey.Border,
    borderWidth: StyleSheet.hairlineWidth,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 12,
    borderBottomRightRadius: 0,
    backgroundColor: CCColors.White,
    padding: 15,
    paddingBottom: 0,
    paddingTop: 0,
    justifyContent: 'center',
  },
  eachMoveInsideWrapper: {
    marginTop: 15,
    flexDirection: 'row',
  },
  AnalysisRightComponentWrapper: {
    flex: 1,
    height: '92vh',
    width: '100%',
    backgroundColor: CCColors.Dashboard.DashboardBackground,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
  },
  label: {
    fontSize: 18,
  },
  count: {
    fontSize: 18,
  },
  playerScore: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
  },
  reviewListScroll: {
    flex: 1,
    minHeight: 0,
  },
  reviewMoveListLoader: {
    minHeight: 220,
    alignItems: 'center',
    justifyContent: 'center',
  },
  reviewMoveListLoaderText: {
    color: '#73695F',
    fontSize: 12,
    fontWeight: '700',
    marginTop: 8,
  },
  reviewListContainer: {
    paddingHorizontal: 0,
    paddingBottom: 12,
  },
  reviewHeaderRow: {
    minHeight: 30,
    borderRadius: 0,
    backgroundColor: '#FAF6EB',
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    marginHorizontal: -14,
    marginBottom: 6,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: 'rgba(77,63,55,0.10)',
  },
  reviewHeaderNo: {
    width: 30,
    color: '#A8A7A6',
    fontSize: 10,
    fontWeight: '900',
    letterSpacing: 0.6,
    textTransform: 'uppercase',
  },
  reviewHeaderCell: {
    flex: 1,
    color: '#8F7A65',
    fontSize: 10,
    fontWeight: '900',
    letterSpacing: 0.6,
    textTransform: 'uppercase',
    paddingHorizontal: 9,
  },
  reviewRows: {
    gap: 4,
  },
  reviewRow: {
    minHeight: 38,
    flexDirection: 'row',
    alignItems: 'stretch',
  },
  reviewMoveNo: {
    width: 30,
    paddingTop: 9,
    color: '#8F7A65',
    fontSize: 12,
    fontWeight: '800',
    textAlign: 'center',
  },
  reviewMoveCell: {
    flex: 1,
    minHeight: 34,
    marginHorizontal: 2,
    paddingHorizontal: 9,
    paddingVertical: 7,
    borderRadius: 8,
    borderWidth: 0,
    backgroundColor: 'transparent',
    justifyContent: 'center',
  },
  reviewMoveCellSelected: {
    backgroundColor: '#FAF0D1',
    borderWidth: 1,
    borderColor: 'rgba(209,171,65,0.50)',
  },
  reviewEmptyCell: {
    flex: 1,
    minHeight: 54,
    marginHorizontal: 3,
  },
  reviewMoveTopLine: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  reviewMoveLeft: {
    flex: 1,
    minWidth: 0,
    flexDirection: 'row',
    alignItems: 'center',
  },
  reviewMoveSan: {
    color: '#4D3F37',
    fontSize: 14,
    fontWeight: '800',
    lineHeight: 18,
  },
  reviewMoveMeta: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 6,
    gap: 8,
  },
  reviewMoveClock: {
    color: '#A79A8F',
    fontSize: 11,
    fontWeight: '600',
  },
  reviewMoveEval: {
    color: '#8F7A65',
    fontSize: 11,
    fontWeight: '700',
  },
  reviewQualityIcon: {
    marginLeft: 6,
    alignItems: 'center',
    justifyContent: 'center',
  },
  reviewBadgeText: {
    fontSize: 11,
    fontWeight: '900',
    lineHeight: 14,
  },
  reviewSummary: {
    marginTop: vs(18),
    marginHorizontal: vs(18),
    width: '90%',
    backgroundColor: 'white',
    padding: vs(8),
    borderRadius: vs(8),
    shadowRadius: vs(2),
    shadowOpacity: 0.5,
    shadowColor: '#4D3F37',
  },
  reviewSummaryHeader: {
    letterSpacing: 2,
  },
  reviewSummaryDescription: {
    marginTop: vs(8),
    letterSpacing: 1,
    lineHeight: vs(18),
  },
  playerScoreEach: {},
  rightReviewTopHeader: {
    backgroundColor: CCColors?.White,
    padding: 10,
    paddingTop: 30,
    paddingBottom: 15,
    fontSize: FontSizes[12],
    color: CCColors?.Tabs.InactiveTabFont,
    minWidth: 100,
    textAlign: 'center',
    width: '34%',
    borderBottomColor: CCColors?.Primary.Default,
    borderBottomWidth: 3,
  },
  rightReviewLeftHeader: {
    justifyContent: 'flex-start',
    padding: 10,
    width: '30%',
    color: CCColors?.White,
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
  },
  selectedMove: {
    backgroundColor: CCColors.Primary.lightYellow,
    borderColor: CCColors.Primary.Default,
    borderWidth: StyleSheet.hairlineWidth,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    padding: 15,
    paddingBottom: 0,
    paddingTop: 0,
    justifyContent: 'center',
  },
  rightReviewTopHeaderSub: {
    backgroundColor: CCColors?.White,
    padding: 10,
    paddingTop: 30,
    paddingBottom: 15,
    fontSize: FontSizes[12],
    color: CCColors?.Tabs.InactiveTabFont,
    minWidth: 100,
    textAlign: 'center',
    width: '33%',
  },
  rightReviewTopHeaderSubSub: {
    fontSize: FontSizes[3],
    height: 'fit-content',
  },
});
export default customStyles;
